import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { Button } from 'ui/baseComponents'

/**
 * Reusable confirmation dialog with cancel/confirm actions.
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is visible
 * @param {Function} props.onClose - Called when the dialog is dismissed
 * @param {Function} props.onConfirm - Called when the confirm button is clicked
 * @param {string} props.title - Dialog title
 * @param {string} props.message - Dialog body text
 * @param {string} [props.confirmLabel='Delete'] - Label for the confirm button
 * @param {boolean} [props.loading=false] - Disables buttons and shows loading state
 */
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Delete',
  loading = false,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Typography>{message}</Typography>
    </DialogContent>
    <DialogActions>
      <Button type="secondary" onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        type="primary"
        onClick={onConfirm}
        disabled={loading}
        sx={{ backgroundColor: 'error.main' }}
      >
        {loading ? `${confirmLabel}...` : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
)

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  loading: PropTypes.bool,
}

export default ConfirmDialog
